import React from "react";

export default function Input(props) {
  const {
    type = "text",
    className,
    required,
    name,
    onChange,
    title,
    label,
    defaultValue = "",
    value,
    disabled,
    placeholder = "",
    component = "",
  } = props;
  return (
    <div className="flex flex-col gap-2 uppercase">
      <label className="text-xs">{label}</label>
      <input
        name={name}
        type={type}
        title={title}
        className={`input input-sm uppercase input-bordered ${className}`}
        required={required ? true : false}
        onChange={(e) => {
          onChange(e);
          const errorElem = document.getElementById(`${component}-${name}`);
          errorElem.style.display = "none";
        }}
        defaultValue={defaultValue}
        value={value && value}
        disabled={disabled ? true : false}
        placeholder={placeholder}
      />
      <p
        id={`${component}-${name}`}
        className="hidden w-full h-5 bg-red/5 text-red text-xs"
      ></p>
    </div>
  );
}
